import { isoDaysFromNow } from "@/mocks/dates";
import { PERSONA_ID, type PersonaId, PERSONAS } from "@/mocks/personas";
import type { ProfileWire } from "@/mocks/types";

type ProfileSeed = Pick<
  ProfileWire,
  "phone" | "birthDate" | "gender" | "careplanRequiresReview"
> & {
  joinedDaysAgo: number;
  lastSessionDaysAgo: number | null;
  notificationsEnabled: boolean;
};

const PROFILE_SEEDS: Record<PersonaId, ProfileSeed> = {
  [PERSONA_ID.APPROVED]: {
    phone: "(555) 010-0101",
    birthDate: "1962-05-14T00:00:00.000000Z",
    gender: "female",
    careplanRequiresReview: false,
    joinedDaysAgo: 2,
    lastSessionDaysAgo: null,
    notificationsEnabled: true,
  },
  [PERSONA_ID.IN_REVIEW]: {
    phone: "(555) 010-0102",
    birthDate: "1958-09-03T00:00:00.000000Z",
    gender: "male",
    careplanRequiresReview: true,
    joinedDaysAgo: 0,
    lastSessionDaysAgo: null,
    notificationsEnabled: false,
  },
  [PERSONA_ID.SUBSCRIBED]: {
    phone: "(555) 010-0103",
    birthDate: "1955-01-27T00:00:00.000000Z",
    gender: "female",
    careplanRequiresReview: false,
    joinedDaysAgo: 63,
    lastSessionDaysAgo: 4,
    notificationsEnabled: true,
  },
  [PERSONA_ID.NOT_SUBSCRIBED]: {
    phone: "(555) 010-0104",
    birthDate: "1967-11-08T00:00:00.000000Z",
    gender: "male",
    careplanRequiresReview: false,
    joinedDaysAgo: 96,
    lastSessionDaysAgo: 30,
    notificationsEnabled: true,
  },
};

export const createInitialProfile = (personaId: PersonaId): ProfileWire => {
  const persona = PERSONAS[personaId];
  const seed = PROFILE_SEEDS[personaId];
  const joinedAt = isoDaysFromNow(-seed.joinedDaysAgo);

  return {
    id: persona.userId,
    firstName: persona.firstName,
    lastName: persona.lastName,
    email: persona.email,
    phone: seed.phone,
    birthDate: seed.birthDate,
    type: "patient",
    isTestUser: true,
    isPersonify: false,
    gender: seed.gender,
    smsEnabledAt: seed.notificationsEnabled ? joinedAt : null,
    emailsEnabledAt: joinedAt,
    klaviyoProfileId: null,
    profilingId: persona.userId + 1000,
    careplanRequiresReview: seed.careplanRequiresReview,
    lastSession: seed.lastSessionDaysAgo === null ? null : isoDaysFromNow(-seed.lastSessionDaysAgo),
    createdAt: joinedAt,
    sms_communication_permissions: seed.notificationsEnabled,
    communication_permissions: true,
  };
};
